import t from "./index49.js";
import b from "./index63.js";
const h = (i) => i instanceof b ? { ...i } : i;
function S(i, s) {
  i = i || {}, s = s || {};
  const u = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(u, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function d(a, e, r, o) {
    return t.isPlainObject(a) && t.isPlainObject(e) ? t.merge.call({ caseless: o }, a, e) : t.isPlainObject(e) ? t.merge({}, e) : t.isArray(e) ? e.slice() : e;
  }
  function f(a, e, r, o) {
    if (t.isUndefined(e)) {
      if (!t.isUndefined(a))
        return d(void 0, a, r, o);
    } else
      return d(a, e, r, o);
  }
  function l(a, e) {
    if (!t.isUndefined(e))
      return d(void 0, e);
  }
  function n(a, e) {
    if (t.isUndefined(e)) {
      if (!t.isUndefined(a))
        return d(void 0, a);
    } else
      return d(void 0, e);
  }
  function c(a) {
    const e = t.hasOwnProp(s, "transitional") ? s.transitional : void 0;
    if (!t.isUndefined(e))
      if (t.isPlainObject(e)) {
        if (t.hasOwnProp(e, a))
          return e[a];
      } else
        return;
    const r = t.hasOwnProp(i, "transitional") ? i.transitional : void 0;
    if (t.isPlainObject(r) && t.hasOwnProp(r, a))
      return r[a];
  }
  function m(a, e, r) {
    if (t.hasOwnProp(s, r))
      return d(a, e);
    if (t.hasOwnProp(i, r))
      return d(void 0, a);
  }
  const O = {
    url: l,
    method: l,
    data: l,
    baseURL: n,
    transformRequest: n,
    transformResponse: n,
    paramsSerializer: n,
    timeout: n,
    timeoutMessage: n,
    withCredentials: n,
    withXSRFToken: n,
    adapter: n,
    responseType: n,
    xsrfCookieName: n,
    xsrfHeaderName: n,
    onUploadProgress: n,
    onDownloadProgress: n,
    decompress: n,
    maxContentLength: n,
    maxBodyLength: n,
    beforeRedirect: n,
    transport: n,
    httpAgent: n,
    httpsAgent: n,
    cancelToken: n,
    socketPath: n,
    allowedSocketPaths: n,
    responseEncoding: n,
    validateStatus: m,
    headers: (a, e, r) => f(h(a), h(e), r, !0)
  };
  return t.forEach(Object.keys({ ...i, ...s }), function(e) {
    if (e === "__proto__" || e === "constructor" || e === "prototype")
      return;
    const r = t.hasOwnProp(O, e) ? O[e] : f, o = t.hasOwnProp(i, e) ? i[e] : void 0, w = t.hasOwnProp(s, e) ? s[e] : void 0, P = r(o, w, e);
    t.isUndefined(P) && r !== m || (u[e] = P);
  }), t.hasOwnProp(s, "validateStatus") && t.isUndefined(s.validateStatus) && c("validateStatusUndefinedResolves") === !1 && (t.hasOwnProp(i, "validateStatus") ? u.validateStatus = d(void 0, i.validateStatus) : delete u.validateStatus), u;
}
export {
  S as default
};
